/**
 * Makes a deep clone of the object by stringify and then parsing it
 * @param object
 */
export function freezeObject<T>(object: T): T {
  return JSON.parse(JSON.stringify(object))
}
